import WeatherOption from 'owa-weather-option/lib/WeatherOption';
import loadCalendarMailboxConfiguration from './loadCalendarMailboxConfiguration';
var weatherSubCategory = {
    key: 'weather',
    titleStringKey: 'optionSubcategory_weather',
    options: [WeatherOption],
    onSelected: loadCalendarMailboxConfiguration,
};
export default weatherSubCategory;
//# sourceMappingURL=weatherSubCategory.js.map